import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { SwitchIconOption } from '@/components/ui/SwitchIconOption';
import { VideoFeatures } from '@/store/videoFeatures';
import { SectionCard } from '@/components/ui/SectionCard';
import { PlayerThemeCard } from './PlayerThemeCard';

interface VideoStyleTabProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const VideoStyleTab: React.FC<VideoStyleTabProps> = ({
  features,
  setFeature,
}) => {
  useLanguage();
  return (
    <div className="space-y-4">
      {/* Card: Aparência dos Controles */}
      <SectionCard
        title={translateInterfaceText("Aparência dos Controles")}
        description={translateInterfaceText("Escolha o estilo visual do botão de play do seu player.")}
      >
        <div className="space-y-4">
          <SwitchIconOption
            label={translateInterfaceText("Escolha o tema")}
            selected={features.controlsTheme || 'minimal'}
            onSelect={(theme) => setFeature('controlsTheme', theme)}
          />
        </div>
      </SectionCard>

      {/* Personalizar Tema - movido para cima (posição premium) */}
      <PlayerThemeCard features={features} setFeature={setFeature} />
    </div>
  );
};
